import { useAtom } from "jotai";
import { Checkbox } from "./Checkbox";
import { shopCurrencyAtom } from "../atoms/atoms";
import { LineItem } from "gpc-shared-types";

export type ItemLineProps = LineItem & {
  selected?: boolean;
  onSelectionChange?: (id: string, selected: boolean) => void;
};

export const ItemLine = ({
  id,
  title,
  currentQuantity,
  variant,
  image,
  selected,
  onSelectionChange,
}: ItemLineProps) => {
  const [shopCurrency] = useAtom(shopCurrencyAtom);

  if (currentQuantity === 0) return null;

  return (
    <div className="gpc__item-line">
      <Checkbox
        checked={selected}
        onChange={() => onSelectionChange?.(id, !selected)}
      />
      <div className="gpc__item-line__image">
        {image != null ? (
          <img src={`${image.url}`} alt="item" />
        ) : (
          <img
            src="https://cdn.shopify.com/s/files/1/0726/8489/6566/products/Main_b9e0da7f-db89-4d41-83f0-7f417b02831d.jpg?v=1676244627"
            alt="item"
          />
        )}
        {/* <img
          src="https://cdn.shopify.com/s/files/1/0726/8489/6566/products/Main_b9e0da7f-db89-4d41-83f0-7f417b02831d.jpg?v=1676244627"
          alt="item"
        /> */}
      </div>
      <div className="gpc__item-line__details">
        <div className="gpc__item-line__name">{title}</div>
        <div className="gpc__item-line__price-quantity">
          <div className="gpc__item-line__quantity">Qty: {currentQuantity}</div>
          <div className="gpc__item-line__price">
            {variant !== null
              ? `${variant.price} ${shopCurrency}`
              : `No price available`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemLine;
